import { hasRoleListGuard } from '@auth/guards/has-role-list.guard';
import { hasSelectedRoleGuard } from '@auth/guards/has-selected-role.guard';
import { isAuthGuard } from '@auth/guards/is-auth.guard';
import { Url } from '@core/enums/url.enum';
import { AppRoutes } from '@core/interfaces/app-routes.interface';
import { chainCanActivateFns } from '@core/utils/chain-can-active-fns.util';
import { lastUrlSegment } from '@core/utils/last-url-segment.util';

export const AUTH_ROUTES: AppRoutes = [
  {
    path: lastUrlSegment(Url.LoginSuccess),
    loadComponent: () =>
      import('@auth/pages/login-callback/login-callback.component').then(
        (m) => m.LoginCallbackComponent,
      ),
  },
  {
    path: lastUrlSegment(Url.LoginSso),
    loadComponent: () =>
      import('@auth/pages/login-sso/login-sso.component').then((m) => m.LoginSsoComponent),
  },
  {
    path: lastUrlSegment(Url.AuthLanding),
    canActivate: [chainCanActivateFns(isAuthGuard, hasRoleListGuard, hasSelectedRoleGuard)],
    loadComponent: () =>
      import('@auth/pages/auth-landing/auth-landing.component').then((m) => m.AuthLandingComponent),
  },
  {
    path: '**',
    redirectTo: Url.LoginSso,
  },
];
